import { AbortedError } from 'src/common/api/extended-emerald-error';
import { ItemNotFound } from 'src/common/helpers/error-code';
import { getDefaultWeightUnitOfMeasure } from 'src/common/helpers/localized-description-helper';
import { createSpan, endSpan } from 'src/common/helpers/tracing-helper';
import { IMessageModal } from 'src/common/interfaces/dtos/IMessageModal';
import { store } from 'src/common/redux/configure-store';
import { EmeraldDialogTypes } from '../../common/enumerations/emerald-dialog-types';
import { IItemInputData } from '../../common/interfaces/IItemInputData';
import { handleDepartmentSale } from '../../department-sale/business-logic/handle-department-sale';
import { popupMessage } from '../../messages/business-logic/popup-message';

export const handleItemNotFound = async (inputData: IItemInputData): Promise<void> => {
  const span = createSpan('handle-error-user-input');
  const isReturnMode = !!store.getState().posMode.returnMode.returnType;
  if (inputData.isManualWeight) {
    inputData.unitOfMeasureCode = getDefaultWeightUnitOfMeasure();
  }

  return new Promise<void>((resolve, reject) => {
    const itemNotFoundMessage: IMessageModal = {
      message: 'ItemErrorControl_ItemNotFound_Begin_With_Id',
      messageArgs: { arg: inputData.itemId ?? '' },
      type: EmeraldDialogTypes.Warning,
      subMessage: 'ItemErrorControl_ItemNotFound_End',
      onAccept: () => {
        endSpan(span);
        handleDepartmentSale(inputData)
          .then(resolve)
          .catch(reject);
      },
      onCancel: () => {
        endSpan(span);
        reject(new AbortedError(ItemNotFound));
      },
      acceptButtonLabel: isReturnMode ? 'DepartmentReturn' : 'DepartmentSale',
      subMessageArgs: { arg: inputData.itemId ?? '' },
      closeButtonLabel: 'Cancel',
    };
    popupMessage(itemNotFoundMessage);
  });
};
export const handleEmeraldItemNotFound = async (): Promise<void> => {
  const span = createSpan('handle-error-user-input');

  return new Promise<void>((resolve, reject) => {
    const itemNotFoundMessage: IMessageModal = {
      message: 'EmeraldItemNotFound',
      type: EmeraldDialogTypes.Error,
      hideCancelButton: true,
      onAccept: () => {
        endSpan(span);
        reject(new AbortedError(ItemNotFound));
      },
      acceptButtonLabel: 'close',
    };
    popupMessage(itemNotFoundMessage);
  });
};

export const handleItemNotFoundIntervention = async (onAccept: () => void): Promise<void> => {
  const span = createSpan('handle-error-user-input');

  return new Promise<void>(() => {
    const itemNotFoundMessage: IMessageModal = {
      message: 'EmeraldItemNotFound',
      type: EmeraldDialogTypes.Error,
      hideCancelButton: true,
      onAccept: () => {
        onAccept();
      },
      acceptButtonLabel: 'Ok',
    };
    popupMessage(itemNotFoundMessage);
  }).finally(() => endSpan(span));
};
